import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames/bind';
import HeaderContainer from 'presentation/containers/HeaderContainer';
import styles from 'presentation/components/styles/__demo__/DemoSelfService.css';
import SearchContainer from 'presentation/containers/__demo__/SearchContainer';
import SuggestedAnswersContainer from 'presentation/containers/__demo__/SuggestedAnswersContainer';
import DeflectionPanelContainer from '../../containers/__demo__/DeflectionPanelContainer';
import AnswerDisplayContainer from '../../containers/__demo__/AnswerDisplayContainer';

let cx = classnames.bind(styles);

export default function DemoSelfService(props) {
  let demoSelfServiceClasses = cx(styles.demoSelfService);
  return (
    <div className={demoSelfServiceClasses}>
      <HeaderContainer />
      <SearchContainer />
      <DeflectionPanelContainer />
      {props.isAnswerSelected ? <AnswerDisplayContainer /> : <SuggestedAnswersContainer />}
    </div>
  );
}
